<template>
    <div v-if="store.getSubMenu() != undefined && !store.getIsPP()" id="container-second-menu" :class="[store.getSubMenu() == null ? 'bottom-submenu' : 'bottom-0']" class="relative h-submenu-desk max-md:h-9">
        <div id="container-option" class="h-full" :class="[store.isMovil ? ['bg-primary-color-1st', 'dark:bg-primary-dark-color-1st'] : 'submenu-degrade']">
            <Splide :options="options" class="h-full flex items-center flex-wrap content-center justify-end w-full">
                <SplideSlide v-if="store.filterC == true" class="text-center text-secondary-desktop font-bloggerM hover:cursor-pointer dark:text-primary-dark-text" :class="[route.name != 'Store' && route.name != 'News' ? 'pointer-events-none' : '']" @click="store.filterC = false; filter = ''"> Todos </SplideSlide>
                <SplideSlide class="text-center text-secondary-desktop font-bloggerM hover:cursor-pointer w-fit dark:text-primary-dark-text" v-for="option in store.getSubMenu()" @click="filtering(option.id); filter = option.name" :class="[filter == option.name ? 'hidden' : '', route.name != 'Store' && route.name != 'News' ? 'pointer-events-none' : '']"> {{ option['name'] }}</SplideSlide>
            </Splide>
        </div>
    </div>
</template>

<script setup>
import { ref, watchEffect } from 'vue';
import { generalStore } from '@/stores';
import { categoriesStore } from '@/stores/categories';
import '@splidejs/vue-splide/css';

const store = generalStore();
const storeC = categoriesStore();

var route = store.route;
var filter = ref('');
var actual = ref('');
store.filterC = false;
var categories = ref(null)
var options = ref({})
var qtyOp = 0;
var qtyMv = 0;

const filtering = async (cat) => {
    if (store.filterN) {
        await store.filterData(store.getSessionStorage('persistSearch')['name'], cat, 'Multiple')
    } else {
        await store.filterData('', cat, 'Cat')
    }
}

watchEffect(async () => {
    actual.value = route.name;
    if (actual.value == 'Store' || actual.value == 'News' || actual.value == 'Modal') {
        if (actual.value == 'Modal') {
            actual.value = 'Store'
        }
        await storeC.loadCategories(actual.value);
        categories.value = store.getSessionStorage('persistCategories-' + actual.value);
        store.setSubMenu(categories.value);

        if (store.getSubMenu() != null) {
            if (store.isMovil) {
                if (store.getSubMenu().length > 4) {
                    qtyOp = 4;
                    qtyMv = 2
                } else {
                    qtyOp = store.getSubMenu().length;
                    qtyMv = 0;
                }
                options = { rewind: true, perPage: qtyOp, perMove: qtyMv, pagination: false, arrows: false, gap: '1rem' };
            } else {
                var arrowsOp = true;
                if (store.getSubMenu().length > 12) {
                    qtyOp = 12;
                    qtyMv = 8
                } else {
                    qtyOp = store.getSubMenu().length;
                    qtyMv = 0;
                    arrowsOp = false;
                }
                options = { rewind: true, perPage: qtyOp, perMove: qtyMv, pagination: false, arrows: arrowsOp, gap: '1rem' };
            }
        }
    }

    if (!store.filterC) {
        filter.value = ''
        store.removeSessionStorage('persistSearch')
    }
})
</script>
